<script setup lang="ts">
import CustomMarkerButton from './HeaderMapButtons/CustomMarkerButton.vue';
import TimeTravelButton from './HeaderMapButtons/TimeTravelButton.vue';
</script>

<template>
  <div class="header-map-buttons">
    <CustomMarkerButton class="header-map-buttons__button" />
    <TimeTravelButton class="header-map-buttons__button" />
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.header-map-buttons {
  position: absolute;
  left: rem(8);
  top: rem(8);
  z-index: 5;
  display: flex;
  flex-direction: row;
  border-radius: rem(8);
  overflow: hidden;
  border: 1px solid $colorGray;
  box-shadow: 0 rem(4) rem(8) 0 rgba(0, 0, 0, 0.25);

  &__button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    padding: rem(8);
    min-width: rem(104);
    max-width: rem(104);
    overflow: hidden;
    border-radius: 0;
    border: none;

    &:not(:last-child) {
      border-right: 1px solid $colorGray;
    }
  }
}
</style>
